import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  GenericWrapper, CustomHeight, FilterHeaderWrapper, FullWidthFlexboxFlexStartGapWithPadding,
  Mr3, RelativeWrapper, AbsoluteLeftTopWrapper, Mx2, Mt4, Mt2,
  FlexCenterWrapper, CustomBorderWrapper, FullWIdthColumnScrollWrapper,
  FullWidthHeightJustifyCenter, ColumnWrapper, Ml3, ElementWithPopupWrapper, PopupWrapper
} from 'wrappers';
import {
  Icon, BorderlessInput, SecondaryTextXs, ClickableIcon, SecondaryTextBase, WhiteTextXs, Empty
} from 'atoms';
import { TextButton } from 'molecules';
import { DownCaretSvg } from 'components/icons';
import { escapedRegex } from 'utils';

export const definition = {
  name: 'IconDropdown',
  controller: Controller,
  initialProps: ({ selectedIcon, icons, label, placeholder, isReadonly, isOpen, tooltipText }) => ({ selectedIcon, icons, label, placeholder, isReadonly, isOpen, tooltipText }),
  props: internalState,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: FilterHeaderWrapper,
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({ isOpen, containerRef, inputRef, isReadonly }) => ({ isOpen, containerRef, inputRef, isReadonly }),
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'LeftSide',
              elements: [
                {
                  component: SecondaryTextXs,
                  name: 'Label',
                  displayValue: ({ label }) => label ?? 'Icon: '
                },
                {
                  wrapper: ElementWithPopupWrapper,
                  renderIf: ({ tooltipText }) => !!tooltipText,
                  name: 'PopupWrapper',
                  elements: [
                    {
                      component: wrap(Empty, Ml3),
                      name: 'SelectedIcon',
                      renderIf: ({ isOpen, selectedIcon, icons }) => !isOpen && selectedIcon && icons.find(i => i.id === selectedIcon)?.icon,
                      displayValue: ({ selectedIcon, icons }) => icons.find(i => i.id === selectedIcon)?.icon
                    },
                    {
                      wrapper: PopupWrapper,
                      name: 'PopupWrapper',
                      displayState: ({ }) => ({ position: 'right' }),
                      elements: [
                        {
                          component: WhiteTextXs,
                          name: 'Text',
                          displayValue: ({ tooltipText }) => tooltipText
                        }
                      ]
                    }
                  ]
                },
                {
                  component: wrap(Icon, Ml3),
                  name: 'SelectedIcon',
                  renderIf: ({ isOpen, selectedIcon, icons, tooltipText }) => !tooltipText && !isOpen && selectedIcon && icons.find(i => i.id === selectedIcon)?.icon,
                  displayValue: ({ selectedIcon, icons }) => icons.find(i => i.id === selectedIcon)?.icon
                },
                {
                  wrapper: GenericWrapper,
                  name: 'SearchWrapper',
                  renderIf: ({ isOpen, selectedIcon }) => isOpen || !selectedIcon,
                  ref: ({ inputRef }) => inputRef ?? null,
                  elements: [
                    {
                      component: wrap(BorderlessInput, Mr3),
                      name: 'SearchInput',
                      displayState: ({ }) => ({ width: '114px', minWidth: '114px' }),
                      bindings: ({ searchVal, placeholder }) => ({ value: searchVal, placeholder: placeholder ?? "Search icon" })
                    },
                  ]
                },
              ]
            },
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ isOpen }) => DownCaretSvg({ up: isOpen, color: window?.settings?.primary_color ?? '#1DBD6B' })
            }
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          name: 'DropdownWrapper',
          displayState: ({ }) => ({ top: '50px', width: '100%' }),
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: CustomHeight,
                  name: 'ListWrapper',
                  displayState: ({ }) => ({ height: 270, width: '100%' }),
                  elements: [
                    {
                      wrapper: FullWidthHeightJustifyCenter,
                      name: 'ButtonWrapper',
                      renderIf: ({ icons, searchVal }) => icons?.filter(icon => icon.labels.find(l => escapedRegex(searchVal).test(l))).length < 1,
                      elements: [
                        {
                          wrapper: ColumnWrapper,
                          name: 'ButtonWrapper',
                          elements: [
                            {
                              component: SecondaryTextBase,
                              name: 'NoIconText',
                              displayValue: ({ }) => 'No results'
                            },
                            {
                              component: wrap(TextButton, Mt2),
                              name: 'Link',
                              bindings: ({ }) => ({ title: 'See all' }),
                            },
                          ]
                        }
                      ]
                    },
                    {
                      wrapper: wrap(FullWidthFlexboxFlexStartGapWithPadding, FullWIdthColumnScrollWrapper),
                      name: 'ListWrapper',
                      renderIf: ({ icons, searchVal }) => icons?.filter(icon => icon.labels.find(l => escapedRegex(searchVal).test(l))).length > 0,
                      elements: [
                        {
                          component: wrap(wrap(ClickableIcon, Mx2), Mt4),
                          name: 'Icon',
                          isListOf: { icon: ({ icons, searchVal }) => icons?.filter(icon => icon.labels.find(l => escapedRegex(searchVal).test(l))) },
                          displayValue: ({ icon }) => icon.icon,
                          bindings: ({ icon }) => ({ icon })
                        }
                      ]
                    },
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
